import React, { useState, useRef, useEffect } from "react";
import VlogViewer from "../VlogViewer/VlogViewer";
import HomeHeader from "../HomeHeader/HomeHeader";
import "./VlogList.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const accordionStyle = {
  ".accordion-button::after": {
    marginLeft: "0",
    marginRight: "auto",
  },
};

const VlogList = ({ title, description, vlogs }) => {
  const [selectedVlog, setSelectedVlog] = useState(null);
  const vlogViewerRef = useRef(null);

  // פונקציה שמבצעת גלילה חלקה לתחילת הוולוג שנבחר
  const scrollToVlogViewer = () => {
    if (vlogViewerRef.current) {
      vlogViewerRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  // כאשר משתנה הוולוג הנבחר, מבצעים גלילה
  useEffect(() => {
    if (selectedVlog) {
      // מעקב קצר כדי לתת ל-React זמן לרנדר את הקומפוננטה
      setTimeout(scrollToVlogViewer, 100);
    }
  }, [selectedVlog]);

  return (
    <div className="container mt-4">
      <HomeHeader title={title} description={description} />

      <div className="row">
        {/* אקורדיון בצד ימין */}
        <div className="col-md-3">
          <div className="accordion mb-3" id="vlogAccordion">
            {vlogs.map((category, index) => (
              <div className="accordion-item" key={index}>
                <h2 className="accordion-header" id={`heading${index}`}>
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${index}`}
                    aria-expanded="false"
                    aria-controls={`collapse${index}`}
                  >
                    {category.topic}
                  </button>
                </h2>
                <div
                  id={`collapse${index}`}
                  className="accordion-collapse collapse"
                  aria-labelledby={`heading${index}`}
                  data-bs-parent="#vlogAccordion"
                >
                  <div className="accordion-body">
                    <ul className="list-group p-1">
                      {category.vlogs.map((vlog) => (
                        <li
                          key={vlog.id}
                          className={`list-group-item ${
                            selectedVlog === vlog.id ? "selected-vlog" : ""
                          }`}
                        >
                          <button
                            title={vlog.id}
                            className="btn btn-link w-100 text-end"
                            onClick={() => setSelectedVlog(vlog.id)}
                          >
                            {vlog.name}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* קומפוננטת הצגת הוולוג בצד שמאל */}
        <div className="col-md-9" ref={vlogViewerRef}>
          {selectedVlog ? (
            <VlogViewer selectedVlog={selectedVlog} />
          ) : (
            <div className="card p-5">
              <div className="card-body">
                <p className="card-subtitle text-center">
                  נא לבחור וולוג לצפייה
                </p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* הוספת סגנון CSS מותאם אישית */}
      <style jsx="true">{`
        .accordion-button::after {
          margin-left: 0 !important;
          margin-right: auto !important;
        }
      `}</style>
    </div>
  );
};

export default VlogList;
